export const SETTINGS_TABS = [
  {
    key: "profile",
    label: "Pharmacy Profile",
    path: "/settings/profile",
  },
  {
    key: "banking",
    label: "Banking",
    path: "/settings/banking",
  },
  {
    key: "users",
    label: "Team Management",
    path: "/settings/users",
  },
  {
    key: "compliance",
    label: "Compliance",
    path: "/settings/compliance",
  },
] as const;

export type SettingsTabKey = (typeof SETTINGS_TABS)[number]["key"];

export const getActiveSettingsTab = (pathname: string): SettingsTabKey => {
  if (pathname.startsWith("/settings/banking")) return "banking";
  if (pathname.startsWith("/settings/users")) return "users";
  if (pathname.startsWith("/settings/compliance")) return "compliance";
  return "profile";
};
